(function () {
  'use strict';

  // Source: 拼装人格测试_6种人格映射整理(1).xlsx and 拼装人格测试(中英文案).xlsx.
  // The quiz engine applies +2 to `main`, +1 to each `auxiliary`, then uses Q8 and Q9 for ties.
  window.CraftTiQuizData = {
    personalityOrder: [
      'curator',
      'virtuoso',
      'stylist',
      'storyteller',
      'time-sculptor',
      'whatever',
    ],
    personalities: {
      curator: {
        name: 'Curator',
        chineseName: '完美主义珍藏家',
        accent: '#9d6c3f',
        backdrop: '#291f3b',
        core: 'You are drawn to perfection and harmony. With a curator’s refined taste, you build every kit as if creating a work of art. When it comes from your hands, every detail feels intentional.',
        hidden: 'Deep down, you have a longing for perfection. Once you start building, you refuse to settle for anything careless. Every detail deserves your full attention.',
        tags: ['Orderliness', 'Collecting', 'Perfectionism'],
      },
      virtuoso: {
        name: 'Virtuoso',
        chineseName: '进阶挑战者',
        accent: '#782626',
        backdrop: '#dca656',
        core: 'You enjoy challenging builds and experimenting with different materials. Paper, glue, and whatever you have on hand can become tools for your imagination. For you, every complex project sharpens your skills and rewards both your mind and your eye.',
        hidden: 'Deep down, you are not made for ordinary things. Complex structures do not scare you. They sharpen your focus. Solving a difficult part gives you hard-earned satisfaction.',
        tags: ['Challenge', 'Focus', 'Excellence'],
      },
      stylist: {
        name: 'Stylist',
        chineseName: '生活布置家',
        accent: '#c86358',
        backdrop: '#ddc49a',
        core: 'You build to style your everyday life. To you, a kit should be more than beautiful. It\'s part of how you create an inviting ambience at home. You are always imagining how each finished build will fit into your home and which place it belongs to.',
        hidden: 'To you, beauty belongs in real life. Rather than keeping a build behind glass, you feel more satisfied when it naturally warms the space around you.',
        tags: ['Ambience', 'Furnish', 'Warmth'],
      },
      storyteller: {
        name: 'Storyteller',
        chineseName: '场景分享型玩家',
        accent: '#d05c69',
        backdrop: '#3e2c4d',
        core: 'You love turning your builds and figurines into fascinating stories. Sharing those stories with friends is half the fun, whether on social media or at in-person events. As a creative maker, you immerse yourself in a vivid miniature world and enjoy inviting others into it.',
        hidden: 'Deep down, you long for resonance. No matter why you started building, once the work is finished, you naturally look for a stage for it.',
        tags: ['Sharing', 'Vivid', 'Imagination'],
      },
      'time-sculptor': {
        name: 'Time Sculptor',
        chineseName: '静心疗愈型玩家',
        accent: '#9d6c3f',
        backdrop: '#0d3151',
        core: 'You devote yourself to building because it brings you peace. Immersive assembly carries you away from the noise of everyday life. You care more about how it feels than how it looks to others. For you, building is a gentle way to return to yourself.',
        hidden: 'You can find comfort in any rhythm of making. To you, building feels almost meditative. When the world gets too loud, simple repeated motions help you return to your inner anchor.',
        tags: ['Comfort', 'Anchor', 'Peace'],
      },
      whatever: {
        name: 'Whatever',
        chineseName: '轻松随缘型玩家',
        accent: '#2f4960',
        backdrop: '#dbbd96',
        core: 'You are a casual maker who can find fun in almost any build. Difficulty? 100% completion? Not your problem. You just vibe, unwind, and enjoy the moment whenever you start a project. You are happy to try all kinds of kits, but never too attached to any one of them.',
        hidden: 'You have a rare kind of ease. You can forgive the harmless flaws and remember that creating is meant to please yourself, not weigh you down.',
        tags: ['Pleasure', 'Ease', 'Freedom'],
      },
    },
    questions: [
      {
        id: 'q1',
        title: 'Something\'s Fishy',
        story: 'The clues are unclear and point to different treasures.',
        prompt: 'You cannot chase them all at once, so you must choose one to seek first:',
        mode: 'single',
        countsTowardResult: false,
        options: [
          {
            id: 'a',
            title: 'The Teacup',
            description: 'Pour in water, and it brews fragrant elixir tea. Enjoy.',
            style: 'healing',
          },
          {
            id: 'b',
            title: 'The Snow Globe',
            description: 'Small in size, worlds inside. Step in and create a miniature world as you wish.',
            style: 'miniature-world',
          },
          {
            id: 'c',
            title: 'The Paper Plane',
            description: 'Write your destination on its wings, then ride it anywhere. Whoosh!—Whoosh!',
            style: 'travel',
          },
          {
            id: 'd',
            title: 'The Key',
            description: 'Any door it opens leads to your dream shop where you can shop for free!',
            style: 'dream-shop',
          },
          {
            id: 'e',
            title: 'The Storybook',
            description: 'Open it, and every story is yours to read, even the ending of A Song of Ice and Fire!',
            style: 'stories',
          },
        ],
      },
      {
        id: 'q2',
        title: 'Why Not ALL?',
        story: 'Before starting your quest, you stop by the corner shop near your home and buy far more treats than any sensible traveler should. To thank you for the generous business, the eccentric shopkeeper lets you grab something from his shelves.',
        prompt: 'Which would you choose?',
        mode: 'grouped-multiple',
        selectionNote: 'Choose up to one item from each group.',
        groupSelectionNote: 'Choose up to one',
        options: [
          {
            id: 'a',
            group: 'Mischief',
            title: 'Temperamental Wand',
            description: 'It may cheer you up or blow you away. Either way, it has opinions.',
            main: 'virtuoso',
          },
          {
            id: 'b',
            group: 'Mischief',
            title: 'Puzzle Box',
            description: 'Solve it to hear that satisfying "click". Too bad it doesn\'t happen very often.',
            main: 'curator',
            auxiliary: ['time-sculptor'],
          },
          {
            id: 'c',
            group: 'Props',
            title: 'Jeweled but Dull Dagger',
            description: 'Too dull for battle, fancy enough for bribery.',
            main: 'virtuoso',
          },
          {
            id: 'd',
            group: 'Props',
            title: 'Delicate Figurines',
            description: 'Good company when you’re bored, and that’s about it.',
            main: 'storyteller',
            auxiliary: ['stylist'],
          },
          {
            id: 'e',
            group: 'Charms',
            title: 'Colorful Glass Lamp',
            description: 'A little too magical for flashlight duty.',
            main: 'storyteller',
            auxiliary: ['stylist'],
          },
          {
            id: 'f',
            group: 'Charms',
            title: 'Wooden Pendant',
            description: 'Carved with mysterious marks. Feels like wood, smells like wood, probably is wood.',
            main: 'time-sculptor',
            auxiliary: ['curator'],
          },
        ],
      },
      {
        id: 'q3',
        title: 'I\'m ____Locked.',
        story: 'On the first day, you jump in at the deep end. An ancient stone gate blocks your way. Night is falling, and you are still trying to crack it open. Beyond it may lie a clear path, or nothing but a dead end.',
        prompt: 'You decide to:',
        mode: 'single',
        options: [
          { id: 'a', title: 'Call it a day.', main: 'time-sculptor', auxiliary: ['curator'] },
          { id: 'b', title: 'Keep at it with full confidence.', main: 'virtuoso' },
          { id: 'c', title: 'Push on before tomorrow changes your mind.', main: 'curator', auxiliary: ['virtuoso'] },
          { id: 'd', title: 'Do what you can and let fate decide.', main: 'whatever' },
        ],
      },
      {
        id: 'q4',
        title: 'Goodnight, World',
        story: 'You are weary from the road. It is time to rest. You step into the only inn around, where the grinning innkeeper tells you every room costs the same. The rooms themselves, however, are another story.',
        prompt: 'Which room would you choose?',
        mode: 'single',
        options: [
          {
            id: 'a',
            title: 'Room for the Tired',
            description: 'A cozy, comfortable room where you can melt right into the bed.',
            main: 'time-sculptor',
            auxiliary: ['stylist'],
          },
          {
            id: 'b',
            title: 'Room for the Royals',
            description: 'A grand room full of luxury furniture and delicate details.',
            main: 'curator',
            auxiliary: ['storyteller'],
          },
          {
            id: 'c',
            title: 'Room for the Detective',
            description: 'A room with secret switches, hidden surprises, and doors you may struggle to open.',
            main: 'virtuoso',
            auxiliary: ['stylist'],
          },
          {
            id: 'd',
            title: 'Room for the Curious',
            description: 'A room made for lovers of fantasy stories. Mind the rabbit hole in the wooden floor.',
            main: 'storyteller',
          },
        ],
      },
      {
        id: 'q5',
        title: 'Draw an Owl',
        story: 'The clues you have collected lead you into a dark cave. Following a sliver of light, you find a stone slab engraved with unreadable letters and a strange device made of tiny mirrors. The answer may lie in a game of light and shadow, once you read the correct letters aloud, the exit may appear.',
        prompt: 'How do you feel now?',
        mode: 'single',
        options: [
          { id: 'a', title: 'Too tricky. Too much work. I’m already confused.', main: 'whatever' },
          {
            id: 'b',
            title: 'Brilliant! Whoever designed this device must be a genius.',
            main: 'virtuoso',
            auxiliary: ['curator'],
          },
          {
            id: 'c',
            title: 'Let’s rest for a while. No need to wear myself out.',
            main: 'time-sculptor',
            auxiliary: ['whatever'],
          },
          {
            id: 'd',
            title: 'I see the trick. Let me try to solve it.',
            main: 'curator',
            auxiliary: ['virtuoso'],
          },
        ],
      },
      {
        id: 'q6',
        title: 'Good Company',
        story: 'There\'s no other way forward. You have to adjust the mirrors again and again and use the dim light to read the letters. Suddenly, footsteps break your focus. Another traveler appears and she seems friendly and interested in the device.',
        prompt: 'Your first reaction is:',
        mode: 'single',
        options: [
          {
            id: 'a',
            title: 'One more person means one more problem!',
            main: 'time-sculptor',
            auxiliary: ['curator', 'virtuoso'],
          },
          { id: 'b', title: 'Maybe I should let her join. Many hands make light work.', main: 'storyteller' },
          {
            id: 'c',
            title: 'Finally, an audience! Surely she wants to hear my heroic tale.',
            main: 'storyteller',
            auxiliary: ['virtuoso'],
          },
          { id: 'd', title: 'A savior at last! Here, you take over.', main: 'whatever' },
        ],
      },
      {
        id: 'q7',
        title: 'La vie est ailleurs.',
        story: 'Finally! You made it out of the cave. Near the exit, a crowd is chattering excitedly about the other treasures.',
        prompt: 'You decide to:',
        mode: 'single',
        options: [
          {
            id: 'a',
            title: 'Lucky I heard that. I want them ALL!',
            main: 'storyteller',
            auxiliary: ['virtuoso'],
          },
          { id: 'b', title: 'Interesting... but I’d better focus on my own quest first.', main: 'curator' },
          {
            id: 'c',
            title: 'I’ll jot down anything that catches my eye for later.',
            main: 'stylist',
            auxiliary: ['whatever'],
          },
          {
            id: 'd',
            title: 'Tempting... but I’d better check my coin purse first.',
            main: 'whatever',
            auxiliary: ['time-sculptor'],
          },
        ],
      },
      {
        id: 'q8',
        title: 'Ariadne\'s Thread',
        story: 'At last, you find the legendary treasure, breathtaking in its splendor. Just as you are about to carry it away, a tiny stranger in a cloak blocks your path, with only a snot bubble peeking out. “What is the greatest thing you gained on this journey?” the figure asks in a soft voice.',
        prompt: 'Your answer is:',
        mode: 'single',
        tieBreakerPriority: 1,
        options: [
          { id: 'a', title: 'A quiet mind and a lighter heart.', main: 'time-sculptor' },
          {
            id: 'b',
            title: 'An impressive quest to reach the once unreachable treasure.',
            main: 'curator',
            auxiliary: ['stylist'],
          },
          { id: 'c', title: 'Quality time with fellow travelers.', main: 'storyteller' },
          {
            id: 'd',
            title: 'Glory worthy of songs and stories.',
            main: 'virtuoso',
            auxiliary: ['storyteller'],
          },
          { id: 'e', title: 'Unexpected fun along an unexpected journey.', main: 'whatever' },
        ],
      },
      {
        id: 'q9',
        title: 'The Journey Ends',
        story: '',
        prompt: 'What will you do with your PRECIOUS?',
        mode: 'single',
        tieBreakerPriority: 2,
        options: [
          { id: 'a', title: 'Post a victory notice ASAP. Hear me roar!', main: 'storyteller' },
          { id: 'b', title: 'Bring it home and find the perfect place.', main: 'stylist' },
          {
            id: 'c',
            title: 'Set the scene around it and paint a portrait for it.',
            main: 'storyteller',
            auxiliary: ['curator'],
          },
          { id: 'd', title: 'Show it off within my small circle.', main: 'time-sculptor' },
          { id: 'e', title: 'Give it to someone dear to me.', main: 'whatever' },
        ],
      },
    ],
  };
})();
